<template>
  <div class="weixin-login">
    <WeixinLoginHeader />
    <component :is="currentLoginStep.component" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import WeixinLoginHeader from '@/weixin/login/components/weixin-login-header';
import WeixinLoginIframe from '@/weixin/login/components/weixin-login-iframe';
import WeixinLoginConnect from '@/weixin/login/components/weixin-login-connect';
import WeixinLoginAccount from '@/weixin/login/components/weixin-login-account';
import { socket } from '@/app/app.service';

export default defineComponent({
  name: 'WeixinLogin',

  /**
   * 标题
   */
  title() {
    return '微信登录';
  },

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      canGoBack: false,
    };
  },

  /**
   * 路由守卫
   */
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.canGoBack = from.name ? true : false;
    });
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      currentLoginStep: 'weixin/login/currentLoginStep',
    }),
  },

  /**
   * 已创建
   */
  created() {
    this.resetLoginStep();

    socket.on('weixinLoginConnect', this.onWeixinLoginConnect);
    socket.on('weixinLoginSucceeded', this.onWeixinLoginSucceeded);
  },

  /**
   * 取消挂载
   */
  unmounted() {
    socket.off('weixinLoginConnect', this.onWeixinLoginConnect);
    socket.off('weixinLoginSucceeded', this.onWeixinLoginSucceeded);
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      resetLoginStep: 'weixin/login/resetLoginStep',
      setCurrentLoginStepName: 'weixin/login/setCurrentLoginStepName',
      setWeixinUserInfo: 'weixin/login/setWeixinUserInfo',
    }),

    ...mapActions({
      weixinLogin: 'weixin/login/weixinLogin',
    }),

    onWeixinLoginConnect(weixinUserInfo) {
      this.setCurrentLoginStepName('connectAccount');
      this.setWeixinUserInfo(weixinUserInfo);
    },

    async onWeixinLoginSucceeded(data) {
      await this.weixinLogin(data);

      if (this.canGoBack) {
        this.$router.back();
      } else {
        this.$router.push('/');
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    WeixinLoginAccount,
    WeixinLoginConnect,
    WeixinLoginIframe,
    WeixinLoginHeader,
  },
});
</script>

<style scoped>
@import './styles/weixin-login.css';
</style>
